import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Input, Radio, RadioChangeEvent, Row, Select, Space } from "antd";

import AddressMaker, { AddressType } from "./AddressMaker";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterCarCategory({
    editMode,
    carCategory,
    onRegisterCarCategory,
}: {
    editMode: string;
    carCategory?: Types.CarCategoryDto;
    onRegisterCarCategory?: () => void;
}) {
    const [form] = Form.useForm();
    const alert = useAlert();

    const [categoryId, setCategoryId] = useState("");
    const [categoryName, setCategoryName] = useState("");
    const [unavailable, setunavailable] = useState("");

    const requestAxiosAddCarCategory = async (data: Types.CarCategoryDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().post(Request.CAR_CATEGORY_URL, data);

        return response.data;
    };

    const {
        loading: loadingAddCarCategory,
        error: errorAddCarCategory,
        data: resultAddCarCategory,
        execute: requestAddCarCategory,
    } = useAsyncAxios(requestAxiosAddCarCategory);

    useEffect(() => {
        if (carCategory === undefined) return;

        form.setFieldsValue(carCategory);
    }, [carCategory]);

    useEffect(() => {
        if (resultAddCarCategory === null) return;

        if (onRegisterCarCategory) onRegisterCarCategory();

        alert.setAlert(AlertType.SUCCESS, "카테고리 추가 성공", "카테고리 추가를 완료하였습니다.");
    }, [resultAddCarCategory]);

    useEffect(() => {
        if (errorAddCarCategory === null) return;

        console.log("errorCarCategory", errorAddCarCategory);
        alert.setAlert(errorAddCarCategory.response.data.code, "카테고리 추가 실패", errorAddCarCategory.response.data.message);
    }, [errorAddCarCategory]);

    const requestAxiosUpdateCarCategory = async (data: Types.CarCategoryDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().put(Request.CAR_CATEGORY_URL + "/" + data.categoryId, data);

        return response.data;
    };

    const {
        loading: loadingUpdateCarCategory,
        error: errorUpdateCarCategory,
        data: resultUpdateCarCategory,
        execute: requestUpdateCarCategory,
    } = useAsyncAxios(requestAxiosUpdateCarCategory);

    useEffect(() => {
        if (resultUpdateCarCategory === null) return;

        if (onRegisterCarCategory) onRegisterCarCategory();

        alert.setAlert(AlertType.SUCCESS, "카테고리 수정 성공", "카테고리 수정을 완료하였습니다.");
    }, [resultUpdateCarCategory]);

    useEffect(() => {
        if (errorUpdateCarCategory === null) return;

        console.log("errorUpdateCarCategory", errorUpdateCarCategory);
        alert.setAlert(errorUpdateCarCategory.response.data.code, "카테고리 수정 실패", errorUpdateCarCategory.response.data.message);
    }, [errorUpdateCarCategory]);

    const onFinish = (values: any) => {
        delete values["confirm"];
        const data: Types.CarCategoryDto = {
            ...values,
        };
        console.log("Received values of form: ", data);

        if (editMode === "add") requestAddCarCategory(data);
        else if (editMode === "update") requestUpdateCarCategory(data);
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="categoryId" label="카테고리 ID">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="categoryName"
                                label="카테고리 이름"
                                rules={[
                                    {
                                        required: true,
                                        message: "카테고리 이름을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="카테고리 이름을 입력해 주세요." onChange={(e) => setCategoryName(e.target.value)} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RegisterCarCategory;
